/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Competitive_3_DetailInputs */

const en_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Throughout his competitive career`)
};

const es_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A lo largo de su carrera competitiva`)
};

const de_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Während seiner gesamten Turnierkarriere`)
};

const zh_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在他的整个竞技生涯中`)
};

const ar_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طوال مسيرته التنافسية`)
};

const fr_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout au long de sa carrière en compétition`)
};

const vi_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trong suốt sự nghiệp thi đấu`)
};

const sw_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katika taaluma yake yote ya mashindano`)
};

const th_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตลอดอาชีพการแข่งขันของเขา`)
};

const bs_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tokom cijele takmičarske karijere`)
};

const ja_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`競技キャリアを通じて`)
};

const ko_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선수 생활 내내`)
};

const pt_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao longo de sua carreira competitiva`)
};

const it_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nel corso di tutta la sua carriera agonistica`)
};

const sv_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under hela sin tävlingskarriär`)
};

const nl_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gedurende zijn hele wedstrijdcarrière`)
};

const da_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gennem hele sin turneringskarriere`)
};

const nb_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gjennom hele turneringskarrieren`)
};

const fi_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koko kilpailuuransa ajan`)
};

const pl_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przez całą karierę turniejową`)
};

const ru_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На протяжении всей спортивной карьеры`)
};

const tr_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turnuva kariyeri boyunca`)
};

const hi_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने पूरे प्रतियोगी करियर में`)
};

const id_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepanjang karier kompetitifnya`)
};

const ms_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepanjang kerjaya kejohanannya`)
};

const cs_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Během celé své soutěžní kariéry`)
};

const el_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σε όλη την αγωνιστική του καριέρα`)
};

const he_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לאורך הקריירה התחרותית שלו`)
};

const af_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deur sy hele kompetisieloopbaan`)
};

const hu_about_content_competitive_3_detail = /** @type {(inputs: About_Content_Competitive_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egész versenyzői pályafutása során`)
};

/**
* | output |
* | --- |
* | "Throughout his competitive career" |
*
* @param {About_Content_Competitive_3_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_competitive_3_detail = /** @type {((inputs?: About_Content_Competitive_3_DetailInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Competitive_3_DetailInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_competitive_3_detail(inputs)
	if (locale === "de") return de_about_content_competitive_3_detail(inputs)
	if (locale === "zh") return zh_about_content_competitive_3_detail(inputs)
	if (locale === "ar") return ar_about_content_competitive_3_detail(inputs)
	if (locale === "fr") return fr_about_content_competitive_3_detail(inputs)
	if (locale === "vi") return vi_about_content_competitive_3_detail(inputs)
	if (locale === "sw") return sw_about_content_competitive_3_detail(inputs)
	if (locale === "th") return th_about_content_competitive_3_detail(inputs)
	if (locale === "bs") return bs_about_content_competitive_3_detail(inputs)
	if (locale === "ja") return ja_about_content_competitive_3_detail(inputs)
	if (locale === "ko") return ko_about_content_competitive_3_detail(inputs)
	if (locale === "pt") return pt_about_content_competitive_3_detail(inputs)
	if (locale === "it") return it_about_content_competitive_3_detail(inputs)
	if (locale === "sv") return sv_about_content_competitive_3_detail(inputs)
	if (locale === "nl") return nl_about_content_competitive_3_detail(inputs)
	if (locale === "da") return da_about_content_competitive_3_detail(inputs)
	if (locale === "nb") return nb_about_content_competitive_3_detail(inputs)
	if (locale === "fi") return fi_about_content_competitive_3_detail(inputs)
	if (locale === "pl") return pl_about_content_competitive_3_detail(inputs)
	if (locale === "ru") return ru_about_content_competitive_3_detail(inputs)
	if (locale === "tr") return tr_about_content_competitive_3_detail(inputs)
	if (locale === "hi") return hi_about_content_competitive_3_detail(inputs)
	if (locale === "id") return id_about_content_competitive_3_detail(inputs)
	if (locale === "ms") return ms_about_content_competitive_3_detail(inputs)
	if (locale === "cs") return cs_about_content_competitive_3_detail(inputs)
	if (locale === "el") return el_about_content_competitive_3_detail(inputs)
	if (locale === "he") return he_about_content_competitive_3_detail(inputs)
	if (locale === "af") return af_about_content_competitive_3_detail(inputs)
	if (locale === "hu") return hu_about_content_competitive_3_detail(inputs)
	return en_about_content_competitive_3_detail(inputs)
});